import script from "./ClosedNoticePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosedNoticePanel.vue?vue&type=script&setup=true&lang=js"

import "./ClosedNoticePanel.vue?vue&type=style&index=0&id=69fa8c2a&scoped=true&lang=css"
import "./ClosedNoticePanel.vue?vue&type=style&index=1&id=69fa8c2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69fa8c2a"]])

export default __exports__